import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import BusinessVerifications from './BusinessVerifications';
import WhatsappProfile from './WhatsappProfile';
import AdminAccounts from './AdminAccounts';
import AdminUserAccounts from './AdminUserAccounts';
import AdminRegularUsers from './AdminRegularUsers';
import TurnstileWidget from './TurnstileWidget';
import api from '../../utils/api';
import { API_CONFIG } from '../../utils/apiConfig';

const greeting = () => {
    const h = new Date().getHours();
    if (h < 12) return 'Good morning';
    if (h < 17) return 'Good afternoon';
    return 'Good evening';
};

const AdminDashboard = () => {
    const [activeTab, setActiveTab] = useState('verifications');
    const [admin, setAdmin] = useState(null);
    const pageVerified = useRef(false);
    const navigate = useNavigate();

    useEffect(() => {
        api.get(API_CONFIG.ADMIN.ME).then(res => {
            if (res.data.status === 'success') setAdmin(res.data.admin);
        }).catch(() => {});
    }, []);

    const handlePageVerify = async (token) => {
        if (pageVerified.current || !token) return;
        pageVerified.current = true;
        try {
            await api.post(API_CONFIG.ADMIN.VERIFY_TURNSTILE, { turnstileToken: token });
        } catch {}
    };

    const handleLogout = async () => {
        try {
            await api.post(API_CONFIG.ADMIN.LOGOUT);
            navigate('/admin/login');
        } catch (error) {
            console.error('Logout error:', error);
            navigate('/admin/login');
        }
    };

    const tabs = [
        { id: 'verifications', label: 'Business Verifications' },
        { id: 'whatsapp', label: 'WhatsApp Profile' },
        { id: 'accounts', label: 'Admin Accounts' },
        { id: 'business-accounts', label: 'Business Accounts' },
        { id: 'regular-users', label: 'Regular Users' }
    ];

    return (
        <div className="min-h-screen bg-gray-100">
            <header className="bg-white shadow">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between items-center py-6">
                        <div className="flex flex-col">
                            <h1 className="text-2xl font-bold text-gray-900">Paymeo Control Centre</h1>
                            {admin && (
                                <p className="text-sm text-gray-600 mt-0.5">
                                    {greeting()}, <span className="font-semibold text-gray-800">{admin.username}</span>
                                    <span className="ml-2 inline-block px-2 py-0.5 bg-blue-100 text-blue-700 rounded-full text-[10px] font-medium uppercase">{admin.role}</span>
                                </p>
                            )}
                        </div>
                        <button
                            onClick={handleLogout}
                            className="bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded-md text-sm font-medium"
                        >
                            Logout
                        </button>
                    </div>
                </div>
            </header>

            <nav className="bg-white shadow-sm">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex space-x-8">
                        {tabs.map(tab => (
                            <button
                                key={tab.id}
                                onClick={() => setActiveTab(tab.id)}
                                className={`py-4 px-1 border-b-2 font-medium text-sm ${
                                    activeTab === tab.id
                                        ? 'border-blue-500 text-blue-600'
                                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                }`}
                            >
                                {tab.label}
                            </button>
                        ))}
                    </div>
                </div>
            </nav>

            <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                {activeTab === 'verifications' && <BusinessVerifications />}
                {activeTab === 'whatsapp' && <WhatsappProfile />}
                {activeTab === 'accounts' && <AdminAccounts />}
                {activeTab === 'business-accounts' && <AdminUserAccounts />}
                {activeTab === 'regular-users' && <AdminRegularUsers />}
            </main>

            <div className="fixed bottom-4 right-4 z-40">
                <TurnstileWidget onVerify={handlePageVerify} />
            </div>
        </div>
    );
};

export default AdminDashboard;
